<span class="p-buttonset">
    <p-button *ngFor="let button of buttons; let i = index"
              [label]="button.label"
              [styleClass]="isSelectedButton(button, i) ? 'bg-brown' : 'bg-outline-brown'"
              [style]="getButtonBorderStyles(button)"
              [disabled]="button.disabled"
              pRipple
              (click)="onButtonClick(button)">
    </p-button>
</span>
